import { forEach } from 'lodash-es';
import { isCustomBranding } from '../../Secuirty';

export const isDashboardSelfHosted = (): boolean => {
    if (!isCustomBranding()) {
        return false;
    }

    const scripts = document.querySelectorAll('script');
    let includesDepractedSrc = false;

    forEach(scripts, (script) => {
        if (script.src.includes('https://emailinterface.s3.amazonaws.com')) {
            includesDepractedSrc = true;
        }
    });

    return includesDepractedSrc;
};
